module.exports = __webpack_public_path__ + "static/media/background-login.f32c6630.png";